<template>
  <dropdown-module transitionName="fade" dropdownClass="bg-white text-right w-64" hideOnClick>
    <template v-slot:reference>
      <span
        class="icon-menu-icon text-2lg cursor-pointer hover:text-primary transition__normal"
        :class="whiteLabel.darkHeader ? 'text-white' : ''"
      ></span>
    </template>
    <div>
      <div>
        <router-link
          v-if="currentInvestor && !currentInvestor.linked"
          :to="{ ...baseRouteConfig, name: 'profile' }"
          class="flex w-full justify-end items-center p-4"
        >
          <p class="mr-4">{{ navProfileName }}</p>
          <span class="icon-admin_icon text-normal text-grey-dark-light"></span>
        </router-link>
      </div>

      <div class="border-t-1 border-b-1 border-grey" v-if="!managerId">
        <div v-for="investor in investors" :key="investor.id" @click="changeCurrentInvestor(investor)">
          <user-dropdown-item :investor="investor" :isActive="currentInvestor && investor.id === currentInvestor.id" />
        </div>
      </div>
      <div>
        <router-link :to="{ ...baseRouteConfig, name: 'login' }" class="flex w-full justify-end items-center p-4">
          <p class="mr-4">{{ $t('Logout') }}</p>
          <span class="icon-logout text-orange"></span>
        </router-link>
      </div>
    </div>
  </dropdown-module>
</template>

<script>
import UserDropdownItem from '@/components/header-components/UserDropdownItem'
import DropdownModule from '@/components/shared/DropdownModule'
import { useInvestorStore } from '@/stores/investor'
import { useCompanyStore } from '@/stores/company'
import localStorageService from '@/core/localstorage.service'

export default {
  components: {
    UserDropdownItem,
    DropdownModule
  },

  setup () {
    const investorStore = useInvestorStore()
    const companyStore = useCompanyStore()

    return {
      investorStore,
      companyStore
    }
  },

  data () {
    return {
      managerId: localStorageService.getItem('managerId')
    }
  },

  computed: {
    investors () {
      return this.investorStore.investors
    },
    currentInvestor () {
      return this.investorStore.currentInvestor
    },
    whiteLabel () {
      return this.companyStore.whiteLabel
    },
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    },
    navProfileName () {
      return this.managerId ? this.$t('Return to Main Page') : this.$t('View Profile')
    }
  },

  methods: {
    changeCurrentInvestor (investor) {
      this.investorStore.setCurrentInvestor(this.investors.find(item => item.id === investor.id))
    }
  }
}
</script>
